import { FGStack, FGButton, FGIcons, FGTypography } from "@fg/design-system";
import React from 'react';

type Props = {
    onClose: ()=>void;
}
const RiskPickerHeader = React.memo((props: Props) => {
    return (
        <FGStack alignItems="center">
            <FGButton onClick={props.onClose} variant="secondary">
                <FGIcons icon="ArrowLeft" size={10} />
            </FGButton>
            <FGTypography tag="label" variant="headline4" color="strong">
                Risk Type
            </FGTypography>
        </FGStack>
    );
});

export default RiskPickerHeader;
